import { useMemo } from "react"
import { DataTable } from "@/components/data-table"
import { Text } from "@/components/tailwind/text"
import { LedgerEntry } from "@/models/ledger"
import { createLedgerColumns } from "./ledger-columns"
import { useLedgerTranslation } from "@/i18n/hooks"
import { filterLedgerEntriesBySearch } from "@/lib/ledger-utils"

interface LedgerTableProps {
    entries: LedgerEntry[];
    searchTerm?: string;
    onCancelEntry?: (entry: LedgerEntry) => void;
    onEditEntry?: (entry: LedgerEntry) => void;
    onPrintReceipt?: (entry: LedgerEntry) => void;
}

export function LedgerTable({ entries, searchTerm = '', onCancelEntry, onEditEntry, onPrintReceipt }: LedgerTableProps) {
    const { t } = useLedgerTranslation()

    // Apply client-side search filtering
    const filteredEntries = useMemo(() => {
        return filterLedgerEntriesBySearch(entries, searchTerm, t)
    }, [entries, searchTerm, t])

    if (filteredEntries.length === 0) {
        return (
            <div className="flex justify-center items-center h-64">
                <Text className="text-gray-500">{t('page.noEntries')}</Text>
            </div>
        )
    }

    return (
        <DataTable
            columns={createLedgerColumns(onEditEntry, onCancelEntry, onPrintReceipt)}
            data={filteredEntries}
            resetPageKey={searchTerm}
            data-testid="ledger-table"
        />
    )
}
